






































































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { CMS } from "@/common/state/cms/cms.api";
import { ModalConfig } from "@/components/root/modal";
import { ref, computed, onMounted, Ref } from "@vue/composition-api";
import { CmsReleaseNotesItem } from "@/common/state/cms/cms.models";
import LinearLoader from "@/components/LinearLoader.vue";
export default Vue.extend({
  components: {
    Modal,
    LinearLoader
  },
  setup() {
    const last_notes: Ref<CmsReleaseNotesItem> = ref({
      version: 1,
      notes: []
    });
    const is_loading_notes = ref(true);
    const config = computed(() => {
      return {
        blank: true,
        title: "",
        desc: "",
        width: "60rem",
        height: "45rem",
        backdropDismiss: true
      } as ModalConfig;
    });

    onMounted(async () => {
      is_loading_notes.value = true;
      const res = await CMS.get_release_notes();
      if (res.success) {
        last_notes.value = res.value[0];
      }
      is_loading_notes.value = false;
    });

    const selected_img = ref("");

    return { config, last_notes, is_loading_notes, selected_img };
  }
});
